import Heading from "../commonComponents/components/Heading.vue";

const components = {
  install:(vue)=>{
    // Heading組件
    vue.component("Heading", Heading);
  }
};
export default components;